(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero__slide'));
        if (!this.slides.length) return;

        this.track = this.querySelector('.hero__track');
        this.viewport = this.querySelector('.hero__viewport');
        this.dotsWrap = this.querySelector('.hero__dots');
        this.prevBtn = this.querySelector('.hero__arrow--prev');
        this.nextBtn = this.querySelector('.hero__arrow--next');
        this.pauseBtn = this.querySelector('.hero__pause');

        this.isSlideMode = this.classList.contains('hero--slide');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.index = 0;
        this.held = false;
        this.userPaused = false;
        this.endedWhileHeld = false;
        this.activeSlide = null;

        this.prevBtn?.addEventListener('click', () => this.go(this.index - 1, true));
        this.nextBtn?.addEventListener('click', () => this.go(this.index + 1, true));
        this.pauseBtn?.addEventListener('click', () => this.togglePause());

        this.addEventListener('mouseenter', () => this.hold(true));
        this.addEventListener('mouseleave', () => this.hold(false));
        this.addEventListener('focusin', () => this.hold(true));
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.hold(false);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        this.setupSwipe();
        this.setupVideos();

        this.onVisibility = () => (document.hidden ? this.stopTimer() : this.restartTimer());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.mq = window.matchMedia('(max-width: 749px)');
        this.onMqChange = () => {
          this.syncVideos();
          this.updatePauseButton();
          this.restartTimer();
        };
        this.mq.addEventListener('change', this.onMqChange);

        this.onBlockSelect = (e) => this.handleBlockSelect(e);
        this.onBlockDeselect = (e) => {
          if (this.contains(e.target)) this.hold(false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.init();
      }

      disconnectedCallback() {
        this.stopTimer();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.mq?.removeEventListener('change', this.onMqChange);
      }

      init() {
        this.visible = this.slides.slice();
        const multiple = this.visible.length > 1;
        if (this.prevBtn) this.prevBtn.hidden = !multiple;
        if (this.nextBtn) this.nextBtn.hidden = !multiple;
        if (this.dotsWrap) this.dotsWrap.hidden = !multiple;
        this.buildDots();
        this.index = 0;
        this.update();
      }

      buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        this.dots = this.visible.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hero__dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => this.go(i, true));
          this.dotsWrap.appendChild(dot);
          return dot;
        });
      }

      go(i, fromUser = false) {
        const n = this.visible.length;
        if (!n) return;
        this.index = (i + n) % n;
        this.update();
      }

      update() {
        const n = this.visible.length;
        const newActive = this.visible[this.index];

        this.visible.forEach((s, i) => {
          const active = i === this.index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          s.setAttribute('aria-label', `${i + 1} / ${n}`);
          s.inert = !active;
        });

        if (this.isSlideMode) {
          this.track.style.transform = `translateX(-${this.index * 100}%)`;
        }

        this.dots?.forEach((d, i) => {
          d.classList.toggle('is-active', i === this.index);
          d.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });

        if (newActive !== this.activeSlide) {
          newActive.querySelectorAll('video').forEach((v) => {
            try { v.currentTime = 0; } catch (e) {}
          });
          this.activeSlide = newActive;
        }

        this.endedWhileHeld = false;
        this.syncVideos();
        this.updatePauseButton();
        this.restartTimer();
      }

      setupVideos() {
        this.slides.forEach((slide) => {
          slide.querySelectorAll('video').forEach((v) => {
            v.muted = true;
            v.setAttribute('muted', '');
            v.setAttribute('playsinline', '');
            if (slide.dataset.advanceOnEnd === 'true') {
              v.addEventListener('ended', () => {
                if (slide !== this.activeSlide || !this.autoplay || this.userPaused) return;
                if (this.held) {
                  this.endedWhileHeld = true;
                } else {
                  this.go(this.index + 1);
                }
              });
            }
          });
        });
      }

      /* Is there a video on this slide that is actually showing at the current screen size?
         (A slide can have a video only for mobile, or only for desktop.) */
      hasVisibleVideo(slide) {
        if (!slide) return false;
        return Array.from(slide.querySelectorAll('video')).some((v) => {
          const wrap = v.closest('.hero__video-wrap');
          return wrap ? wrap.getClientRects().length > 0 : true;
        });
      }

      syncVideos() {
        this.slides.forEach((slide) => {
          slide.querySelectorAll('video').forEach((v) => {
            const wrap = v.closest('.hero__video-wrap');
            const isShown = wrap ? wrap.getClientRects().length > 0 : true;
            const shouldPlay = slide === this.activeSlide && !slide.hidden && isShown && !this.userPaused;
            if (shouldPlay) {
              const p = v.play();
              if (p && p.catch) p.catch(() => {});
            } else {
              v.pause();
            }
          });
        });
      }

      restartTimer() {
        this.stopTimer();
        if (!this.autoplay || this.held || this.userPaused || document.hidden) return;
        if (!this.visible || this.visible.length < 2) return;
        if (this.activeSlide?.dataset.advanceOnEnd === 'true' && this.hasVisibleVideo(this.activeSlide)) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.speed);
      }

      stopTimer() {
        clearTimeout(this.timer);
      }

      hold(state) {
        this.held = state;
        if (state) {
          this.stopTimer();
        } else if (this.endedWhileHeld) {
          this.endedWhileHeld = false;
          this.go(this.index + 1);
        } else {
          this.restartTimer();
        }
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        this.syncVideos();
        this.updatePauseButton();
        this.restartTimer();
      }

      updatePauseButton() {
        if (!this.pauseBtn) return;
        const hasVideo = this.hasVisibleVideo(this.activeSlide);
        const hasAutoplay = this.autoplay && this.visible.length > 1;
        this.pauseBtn.hidden = !(hasVideo || hasAutoplay);
        this.pauseBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
      }

      setupSwipe() {
        let startX = null;
        let startY = null;
        let swiped = false;

        this.viewport.addEventListener('pointerdown', (e) => {
          startX = e.clientX;
          startY = e.clientY;
          swiped = false;
        }, { passive: true });

        this.viewport.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            swiped = true;
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          }
        });

        this.viewport.addEventListener('pointercancel', () => (startX = null));

        this.viewport.addEventListener('click', (e) => {
          if (swiped) {
            e.preventDefault();
            e.stopPropagation();
            swiped = false;
          }
        }, true);
      }

      handleBlockSelect(e) {
        const slide = e.target.closest ? e.target.closest('.hero__slide') : null;
        if (!slide || !this.contains(slide)) return;
        const i = this.visible.indexOf(slide);
        this.hold(true);
        if (i > -1) this.go(i);
      }
    }

    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
